import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { addppointmentservice } from '../../upgrade/addappointment/addappointment.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AppointmentService } from 'app/upgrade/appointment.service';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { SearchDialogComponent } from 'app/table-list/Searchdialog/SearchDialoag.component';
import { SearchApptDialogComponent } from '../../upgrade/search-appt-dialog/search-appt-dialog.component';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { PatientFieldsModel } from 'app/table-list/Models/patient_mendatory_fields_config.model';
import { Phoneno_confirmation_dialogComponent } from 'app/table-list/phoneno_confirmation_dialog/phoneno_confirmation_dialog.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { Observable, fromEvent, interval } from 'rxjs';
import { exhaustMap, map, startWith, take, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

export interface IGetServiceData {
  pkServiceId: number;
  fkCategoryId: number;
  serviceName: string
  fkTestTypeId: number;
}

export interface IApptType {
  PKApptTypeId: number;
  ApptType: string;

}

@Component({
  selector: 'app-short-registore',
  templateUrl: './short-registore.component.html',
  styleUrls: ['./short-registore.component.scss']
})


export class ShortRegistoreComponent implements OnInit {
  @ViewChild('defaultauto', { static: false }) private defaultautoRef: ElementRef;
  @ViewChild('autofax', { static: false }) private autofaxRef: ElementRef;
  tdate = this.authService.getServerDate;
  public GetServiceData = [];
  animal: string;
  dobDate: string;
  yearList: string;
  yearAge: number;
  strDate: string;
  strOther: string;
  user_validated = "";
  isFavorite: boolean = false;
  vipselected = false;
  checkgender:boolean=true;
  controlfocusout:boolean=false;
  patient_mendatory_fields: PatientFieldsModel[] = [];
  phonedata: any;
  filterTerm:any; 
  filterTerm1:any;
  TempId: any;
  filterreferd:any;
  ReferedbyCtrl: FormControl;
  filtercountry:any;
  filterstate:any;
  filteredReferedbyArray: Observable<any[]>;
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<ShortRegistoreComponent>, public authService: AuthService,
    public http: HttpClient, public appservice: AppointmentService, public opdvisitService: OpdVisitService, public AddAppointmentService: addppointmentservice, public dashboardService: DashboardService, public addappservice: addppointmentservice, private datePipe: DatePipe) {
    dialogRef.disableClose = true;
  
  }
  ngAfterViewInit(): void {

    fromEvent(this.button.nativeElement, 'click')
      .pipe(
        tap((x) =>  this.isFavorite = true),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());
     
      this.dashboardService.getnationality('NATIONALITY').subscribe((item:any)=>{
        this.dashboardService.GetNationality =item;
        if(this.dashboardService.GetNationality.length >0){
          var nationaldata = this.dashboardService.GetNationality.filter(item => item.popupDescription.toLowerCase() == 'indian');       
         this.opdvisitService.patientdetails.fkNationalityId = nationaldata[0]?.pkPopupId ?nationaldata[0]?.pkPopupId:0;
         this.opdvisitService.patientdetails.nationality = nationaldata[0]?.popupDescription?nationaldata[0]?.popupDescription:'';
        }else{
          this.opdvisitService.patientdetails.fkNationalityId =null;
          this.opdvisitService.patientdetails.nationality =null;
        }
       
      },err=>{
        this.dashboardService.openSnackBar("API Failed", "OK");
      })
   
      
  }
  @ViewChild('shorRegCreateBtn', { static: true }) button;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));

  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.check_user_validation()
      },
      error: (err) => {

      },

    };
  }

  ngOnInit() {
    this.opdvisitService.agehide = false;
    this.opdvisitService.patientdetails={};
    this.get_patients_fields_config();
    this.opdvisitService.patientdetails.initial = null;
    this.opdvisitService.patientdetails.careofType=null
    this.opdvisitService.set_date_and_time();
    this.opdvisitService.getcountries();
   // this.opdvisitService.getinitials();
    this.opdvisitService.getpartymaster();
   // this.opdvisitService.getpersonmaster('REGISTRATION',0);
  //  this.dashboardService.get_otherinformation_tab_dd('MARITALSTATUS');
  //  this.dashboardService.get_otherinformation_tab_dd('VIPREF');
    this.opdvisitService.is_surNameEdit = false;
    this.opdvisitService.callsepecificApi='ALL';
    this.referedbyControll();
    setTimeout(() => {
      this.autofaxRef.nativeElement.focus();
    }, 300);
  }
  

  getstates(countryid: number, option: number) {
    this.opdvisitService.stateid=0;
    this.opdvisitService.districtid =0;
    this.opdvisitService.patientdetails.fkPcityId=0
    this.opdvisitService.getstates(countryid, option);
  }

  getcities(disid: number, option: number) {
    this.opdvisitService.patientdetails.fkPcityId=0
    this.opdvisitService.getcities(disid, option);
  }
  getarea(cityid: number, option: number) {
    console.log("cityid " + cityid)
    this.opdvisitService.getareas(cityid, option);
  }
  getdistricts(stateid: number, option: number) {
    this.opdvisitService.districtid =0;
    this.opdvisitService.patientdetails.fkPcityId=0
    this.opdvisitService.getdistricts(stateid, option);
  }
  fill_gender_and_careof(initials: string) {
  
    var selectedinitials = this.opdvisitService.initials.find(item => item.initialName == initials);
    
    if (selectedinitials.sex!=" ") {
      this.opdvisitService.patientdetails.sex = selectedinitials.sex;
      this.checkgender=true;
    
    }else if(selectedinitials.sex==" "){
      this.checkgender=false;
      this.opdvisitService.patientdetails.sex = selectedinitials.sex;
    }
    this.opdvisitService.patientdetails.careofType = selectedinitials.careof;
   
  }
 
  validateNo(e:any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
}
  //SearchDialog for Patient Search from Patient Registration
  opensearchD(type:any):void {

    //this.open_loader_Dialog();
    // this.dashboardService.showspinner = true;
    // this.opdvisitService.get_top_200_patients().subscribe(
    //   data => this.success_top_200_patients(data),
    //   err => this.failed_top_200_patients(err)
    // );
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "90%",
      data: [{TempShow:true,Type:type}]  
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result >0){
        this.controlfocusout=true;
        this.defaultautoRef.nativeElement.focus();
        console.log("The dialog was closed");
        if(this.opdvisitService.patientdetails.isvip ==true){
          this.vipselected = true;
        }
      }else{
        this.controlfocusout=false;
      }
    });
  }

  // success_top_200_patients(data) {
  //  // this.dialog.closeAll();
  //   // this.dashboardService.showspinner = false;
  //   this.opdvisitService.patients = data;
  //   console.log("patients successfully loaded");

  //   // call dialogue once data get loaded inside success
  //   const dialogRef = this.dialog.open(SearchDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if(result >0){
  //       this.controlfocusout=true;
  //       this.defaultautoRef.nativeElement.focus();
  //       console.log("The dialog was closed");
  //       if(this.opdvisitService.patientdetails.isvip ==true){
  //         this.vipselected = true;
  //       }
  //     }else{
  //       this.controlfocusout=false;
  //     }
  //   });
  // }
  //

  enablevipdd(event) {
  
    if (event.checked == true) {
      this.vipselected = true;
    } else {
      this.vipselected = false;
      this.opdvisitService.patientdetails.fkViprefId=null;
      this.opdvisitService.patientdetails.viptype="";
    }
  }
  //Patient Configuration
  get_patients_fields_config() {
    this.opdvisitService.getPatientConfig()
      .subscribe(

        data => this.success_config(data), err => this.error_config(err)

      )
  }
  success_config(data) { 

    this.patient_mendatory_fields = data;
   if (this.patient_mendatory_fields.length == 0) {
    this.dashboardService.openSnackBar("Please Update The Configuration The Patient in Masters ", "OK");
  } else {
    this.set_default_values();
    if(this.patient_mendatory_fields[0]?.mandatoryInitial != true){
      this.checkgender=false;
    }
  }
  }
  error_config(err) {

  }
  set_default_values(){
  
    if(this.patient_mendatory_fields[0].fK_InitialId != null){
    
      for (let initial of this.opdvisitService.initials) {
        if (initial.pK_InitialId == this.patient_mendatory_fields[0].fK_InitialId ) {
    
          this.opdvisitService.patientdetails.initial = initial.initialName;
          this.fill_gender_and_careof(this.opdvisitService.patientdetails.initial);
         
        }
      } 
    
    }
    
    
        if(this.patient_mendatory_fields[0].fL_SourceId != null){
          this.opdvisitService.patientdetails.fkSourceId = this.patient_mendatory_fields[0].fL_SourceId;
       }
       if(this.patient_mendatory_fields[0].fK_CityId != null){
         this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0].fK_CityId, 1);
       }
       
      }
  //
 
  
  open_loader_DialogShort(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }

  //om
  GetMoreApptCount() {
    if (this.opdvisitService.apptdetail.fkRegId != null) {
      this.opdvisitService.getfutureAppt().
        subscribe(

          data => this.success_count(data), err => this.error_count(err)

        )
    }
    else {
      this.opdvisitService.saveapptdetails(this.authService.Loggeduser.branchid);
    }

  }




  success_count(data) {
    // alert("working till here");
    this.opdvisitService.futureApptCount = data;

    if (this.opdvisitService.futureApptCount > 0) {
      this.dashboardService.openSnackBar("Patient already got appointment for future, do you want to continue", "OK");
      this.opdvisitService.futureApptCount = 0;
      this.opdvisitService.saveapptdetails(this.authService.Loggeduser.branchid);
    }
    else {

      this.opdvisitService.saveapptdetails(this.authService.Loggeduser.branchid);
    }
  }
  error_count(err) {

  }
  get_top_200_patients() {
  
    const dialogRef = this.dialog.open(SearchApptDialogComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      height: '70%',
      width: '90%',
    });

    dialogRef.afterClosed().subscribe(result => {

      this.defaultautoRef.nativeElement.focus();
      console.log('The dialog was closed');
      this.animal = result;
    });

  }

  failed_top_200_patients(err) {
    this.dialog.closeAll();
   

  }

  showAge(dobYear, dobMonth, dobDay) {
    var bthDate, curDate, days;
    var ageYears, ageMonths, ageDays;
    bthDate = new Date(dobYear, dobMonth - 1, dobDay);
    curDate = this.authService.getServerDate;;
    if (bthDate > curDate) return;
    days = Math.floor((curDate - bthDate) / (1000 * 60 * 60 * 24));
    ageYears = Math.floor(days / 365);
    ageMonths = Math.floor((days % 365) / 31);
    ageDays = days - (ageYears * 365) - (ageMonths * 31);
    if (ageYears > 0) {
      document.write(ageYears + " year");
      if (ageYears > 1) document.write("s");
      if ((ageMonths > 0) || (ageDays > 0)) document.write(", ");
    }
    if (ageMonths > 0) {
      document.write(ageMonths + " month");
      if (ageMonths > 1) document.write("s");
      if (ageDays > 0) document.write(", ");
    }
    if (ageDays > 0) {
      document.write(ageDays + " day");
      if (ageDays > 1) document.write("s");
    }
    var dtrAge = ageMonths, ageMonths, ageDays
    return dtrAge;
  }

  
  getVIP(event) {
    this.opdvisitService.apptdetail.isVip = event.checked;
   
  }

  getage(selecteddate: string) {
    
    // let container = selecteddate.split("/", 3);

    // let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

    // let currenttime = this.datePipe.transform(new Date(), "hh:mm:ss");
  
    // let dateofbirth = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");

    // let currentdate = this.datePipe.transform(new Date, "yyyy-MM-dd");

    // this.getDataDiff(new Date(dateofbirth), new Date(currentdate));
    const checkcdate= this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let currentdate = this.authService.getServerDate;
    if(currentdate >= checkcdate){
      this.getDataDiff(new Date(selecteddate), new Date(currentdate));
    }else{
      this.opdvisitService.patientdetails.dob=this.authService.getServerDate;
      this.opdvisitService.patientdetails.ageYear = 0;
      this.opdvisitService.patientdetails.ageMonth = 0;
      this.opdvisitService.patientdetails.ageDays = 0;
    }
   
  }

 
  // DOb validation
  getdob(type:any) {
    switch(type){
      case 1:{
        var tdate = new Date();
        if(this.opdvisitService.patientdetails.ageYear==null || this.opdvisitService.patientdetails.ageYear == undefined){
          this.opdvisitService.patientdetails.ageYear=0;
        } 
        this.opdvisitService.patientdetails.ageMonth=0;
        this.opdvisitService.patientdetails.ageDays=0;
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 2:{
        var tdate = new Date();
        if (this.opdvisitService.patientdetails.ageMonth > 11 || this.opdvisitService.patientdetails.ageMonth <= 0) {
          this.dashboardService.openSnackBar("Please enter months in between 0 to 12", "OK");
          this.opdvisitService.patientdetails.ageMonth=0;
          return false;
        } 
        if(this.opdvisitService.patientdetails.ageYear==undefined || this.opdvisitService.patientdetails.ageYear==null){
          this.opdvisitService.patientdetails.ageYear=0;
        }
        this.opdvisitService.patientdetails.ageDays=0;
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 3:{
        var tdate = new Date();
        if (this.opdvisitService.patientdetails.ageDays > 31 || this.opdvisitService.patientdetails.ageDays <= 0) {
          this.dashboardService.openSnackBar("Please enter days in between 0 to 31", "OK");
          this.opdvisitService.patientdetails.ageDays=0;
          return false;
        }
        if((this.opdvisitService.patientdetails.ageMonth==undefined || this.opdvisitService.patientdetails.ageMonth==null) && (this.opdvisitService.patientdetails.ageYear ==undefined || this.opdvisitService.patientdetails.ageYear ==null)){
          this.opdvisitService.patientdetails.ageMonth=0;
          this.opdvisitService.patientdetails.ageYear=0;
        }
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
         this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
      }
    }
    
    }


  getDataDiff(start, end) {


    let years: number = 0, months: number = 0, days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.opdvisitService.patientdetails.ageYear = years;
    this.opdvisitService.patientdetails.ageMonth = months;
    this.opdvisitService.patientdetails.ageDays = days;


  }

  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  clear_and_set_default(){
    this.clearfields();
    this.validateobject();
    this.set_default_values();
  }
  clearfields() {
    this.TempId = null;
    this.opdvisitService.agehide = false;
    // this.addresschecked = false;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.patientdetails.fkPcityId = null;
    this.opdvisitService.stateid = 0;
  
    this.opdvisitService.districtid = 0;
    
    this.opdvisitService.countryid = 0;
    this.opdvisitService.patientdetails.fkMaritalId = 0;
    this.opdvisitService.patientdetails.fkNationalityId = 0;
    this.opdvisitService.patientdetails.nationality = null;
    this.opdvisitService.patientdetails.fkViprefId = 0;
    this.opdvisitService.patientdetails.fkPartyId = 0;
    this.opdvisitService.patientdetails.initial = null;
    this.opdvisitService.patientdetails.careofType="S/o"
    this.opdvisitService.patientdetails.fkReferredbyId = 0;
    this.opdvisitService.patientdetails.referredBy=null;
    this.opdvisitService.states = [];
   
    this.opdvisitService.districts = [];
  
    this.opdvisitService.cities = [];
    this.opdvisitService.patientdetails.emailAddress=null;
    this.opdvisitService.patientdetails.paddress =null;
    this.opdvisitService.patientdetails.remarks=null;
   this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0]?.fK_CityId, 1);
   

  }
  validateinitial:boolean =false;
  ValidatefirstName:boolean=false;
  ValidatelastName: boolean = false;
  validatemobile:boolean=false;
  validateaddress:boolean=false;
  validatemandatoryDOB:boolean=false;
  validateDOBAge:boolean=false;
  validateemail:boolean=false;
  validatemaritalstatus:boolean=false;
  validateoldmrno:boolean=false;
  validatereferredby:boolean=false;
  validatepartyname:boolean=false;
  validateemergencymobno:boolean=false;
  validatepincode:boolean=false;
  validategender:boolean=false;
  validatecountryName:boolean=false;
  validatestateName:boolean=false;
  validateDistrictName:boolean=false;
  validateCityName:boolean=false;
  Validatevip:boolean =false;
 
  check_user_validation() {
   this.isFavorite = false;
   this.validate_initial();
   this.Validate_firstName();
   this.Validate_lastName();
   this.Validate_vip();
   this.validate_DOBAge();
   this.validate_mobile();
   this.validate_address();
   this.validate_pincode();
   this.validate_mandatoryDOB();
   this.validate_email();
   this.validate_marital_status();
   this.validate_oldmrno();
   this.validate_gender();
   this.validate_partyname();
   this.validate_emergency_mob_no();
   this.validate_countryName();
   this.validate_stateName();
   this.validate_DistrictName();
   this.validate_CityName();
   this.validate_referredby();
   this.validate_abhaid()
   if(this.user_validated != "") {
    
     const newstring = this.user_validated.substring(0, this.user_validated.length - 2);
     this.dashboardService.
     openSnackBar_regform("Please check all mandatory fields marked with * "+" " + newstring , "OK");
     this.user_validated = "";
   }
   else {
    // this.opdvisitService.patientdetails.firstName =this.checkTitlecase(this.opdvisitService.patientdetails.firstName);
    //   if(this.opdvisitService.patientdetails.lastName !=null && this.opdvisitService.patientdetails.lastName !=undefined &&  this.opdvisitService.patientdetails.lastName != ""){
    //     this.opdvisitService.patientdetails.lastName =this.checkTitlecase(this.opdvisitService.patientdetails.lastName);
    //   }
      if(this.opdvisitService.patientdetails.careofName !=null && this.opdvisitService.patientdetails.careofName !=undefined &&  this.opdvisitService.patientdetails.careofName != ""){
        this.opdvisitService.patientdetails.careofName =this.checkTitlecase(this.opdvisitService.patientdetails.careofName);
      }
    
      if(this.opdvisitService.patientdetails.motherName !=null && this.opdvisitService.patientdetails.motherName !=undefined &&  this.opdvisitService.patientdetails.motherName != ""){
        this.opdvisitService.patientdetails.motherName =this.checkTitlecase(this.opdvisitService.patientdetails.motherName);
      }
     this.validateobject();
     this.savedetails();
    
   }
 }
 checkTitlecase(value){
  if(value!=null && value!=''){
    return  value = (value.length > 1) ? value[0].toUpperCase() + value.substr(1).toLowerCase() : value.toUpperCase();
  }else{
    return  value;
  }
 
  }
  validateobject(){
    this.validateinitial =false;
    this.ValidatefirstName=false;
    this.ValidatelastName = false;
    this.validatemobile=false;
    this.validateDOBAge=false;
    this.validateaddress=false;
    this.validatemandatoryDOB=false;
    this.validateemail=false;
    this.validatemaritalstatus=false;
    this.validateoldmrno=false;
    this.validatereferredby=false;
    this.validatepartyname=false;
    this.validateemergencymobno=false;
    this.validatepincode=false;
    this.validategender=false;
    this.validatecountryName=false;
    this.validatestateName=false;
    this.validateDistrictName=false;
    this.validateCityName=false;
    this.Validatevip =false;
  }
  validate_referredby() {
    if (this.patient_mendatory_fields[0].mandatoryReferredby == true) {
      if (this.opdvisitService.patientdetails.fkReferredbyId == 0 || this.opdvisitService.patientdetails.fkReferredbyId == null ) {
        this.validatereferredby=true;
        this.user_validated = this.user_validated + " " + "REFERRED BY, " + " \n";
      }
    }
  }
 validate_pincode() {
  if (this.patient_mendatory_fields[0].mandatoryPincode == true) {  
    // console.log((this.opdvisitService.patientdetails.pinCode).toString())
    if (this.opdvisitService.patientdetails.pinCode ==undefined &&  this.opdvisitService.patientdetails.pinCode == null  ) {
      this.validatepincode=true;
      this.user_validated = this.user_validated + " " + "PINCODE, " + " \n";
    }else if(this.digits_count(this.opdvisitService.patientdetails.pinCode) < 4){
      this.user_validated = this.user_validated + " " + "Please enter minimum 4 digit pincode, " + " \n";
    }
  }
  
}

validate_abhaid() {
  if (this.opdvisitService.patientdetails.abhaID != null && this.opdvisitService.patientdetails.abhaID != "") {
    if (this.digits_count(this.opdvisitService.patientdetails.abhaID) != 14) {
      this.user_validated = this.user_validated + " " + "Please enter 14 digit ABHA ID Number, " + " \n";
    }
  }
}

 validate_countryName(){
  if (this.opdvisitService.countryid == null || this.opdvisitService.countryid == 0) {
    this.validatecountryName=true;
    this.user_validated = this.user_validated + " " + "Country Name, " + " \n";
  }
}
validate_stateName(){
  if (this.opdvisitService.stateid == null || this.opdvisitService.stateid == 0) {
    this.validatestateName=true;
    this.user_validated = this.user_validated + " " + "State Name, " + " \n";
  }
}
validate_DistrictName(){
  if (this.opdvisitService.districtid == null || this.opdvisitService.districtid == 0) {
    this.validateDistrictName=true;
    this.user_validated = this.user_validated + " " + "District Name, " + " \n";
  }
}
validate_CityName(){
  if (this.opdvisitService.patientdetails.fkPcityId == null || this.opdvisitService.patientdetails.fkPcityId == 0) {
    this.validateCityName=true;
    this.user_validated = this.user_validated + " " + "City Name, " + " \n";
  }
}
 Validate_firstName(){
    if(this.opdvisitService.patientdetails.firstName==null || this.opdvisitService.patientdetails.firstName == ""){
      this.ValidatefirstName=true;
      this.user_validated = this.user_validated + " " + "First Name, " +" \n";
    }
 }
 Validate_lastName() {
    if (this.opdvisitService.patientdetails.lastName == null || this.opdvisitService.patientdetails.lastName == "") {
      this.ValidatelastName = true;
      this.user_validated = this.user_validated + " " + "Last Name, " + " \n";
  }
 
}


 Validate_vip(){
 
  if(this.opdvisitService.patientdetails.isvip == true){
    if(!this.opdvisitService.patientdetails.viptype){
      this.Validatevip =true;
    this.user_validated = this.user_validated + " " + "VIP Type, " +" \n";
    }
   }
 
 }
 validate_address() {
   if (this.patient_mendatory_fields[0].mandatoryAddress == true) {
     if (this.opdvisitService.patientdetails.paddress == null || this.opdvisitService.patientdetails.paddress == "") {
      this.validateaddress=true;
      this.user_validated = this.user_validated + " " + "Address, " +" \n";
     }
   }
 }
 validate_mobile() {
 
   if (this.patient_mendatory_fields[0].mandatoryMobile == true) {
     if (this.opdvisitService.patientdetails.mobileNo == null) {
      this.validatemobile=true;
       this.user_validated = this.user_validated + " " + "Mobile No. , " +" \n";  
   
     }else if(this.digits_count(Number(this.opdvisitService.patientdetails.mobileNo))!=10){
      this.user_validated = this.user_validated + " " + "Enter 10 Digit Mobile No. , " +" \n";
     }
     
   }
  
 }

 validate_mandatoryDOB() {

   if (this.patient_mendatory_fields[0].mandatoryDOB == true) {
     if (this.opdvisitService.patientdetails.dob == null) {
      this.validatemandatoryDOB=true;
      this.user_validated = this.user_validated + " " + "DOB, " +" \n";
     }
   }
 }

 validate_email() {
   
   if (this.patient_mendatory_fields[0].mandatoryEmail == true) {
     if (this.opdvisitService.patientdetails.emailAddress == null || this.opdvisitService.patientdetails.emailAddress == "") {
      this.validateemail=true;
      this.user_validated = this.user_validated + " " + "EMAIL, " +" \n";
     }
   }
 }
 validate_marital_status() {
   if (this.patient_mendatory_fields[0].mandatoryMaritalStatus == true) {
     if (this.opdvisitService.patientdetails.meritalStatus == null || this.opdvisitService.patientdetails.meritalStatus == "") {
      this.validatemaritalstatus=true;
      this.user_validated = this.user_validated + " " + "MARITAL STATUS, " +" \n";
     }
   }
 }

 validate_oldmrno() {
   if (this.patient_mendatory_fields[0].mandatoryOldmrno == true) {
     if (this.opdvisitService.patientdetails.oldMrno == null) {
      this.validateoldmrno=true;
      this.user_validated = this.user_validated + " " + "Old UHID, " +" \n";
     }
   }
 }
 validate_partyname() {
   if (this.patient_mendatory_fields[0].mandatoryPartyName == true) {
     if (this.opdvisitService.patientdetails.fkPartyId == 0) {
      this.validatepartyname=true;
       this.user_validated = this.user_validated + " " + "PARTY NAME, " +" \n";
     }
   }
 }
 validate_initial() {
   if (this.patient_mendatory_fields[0].mandatoryInitial == true) {
     if (this.opdvisitService.patientdetails.initial == null || this.opdvisitService.patientdetails.initial == "") {
      this.validateinitial=true;
       this.user_validated = this.user_validated + " " + "Initial, " +" \n";
     }
    // this.validate_gender();
   }
 }

 validate_occupation() {
   if (this.patient_mendatory_fields[0].mandatoryOcupation == true) {
     if (this.opdvisitService.patientdetails.fkOccupationId == 0) {
       this.user_validated = this.user_validated + " " + "OCCUPATION, " +" \n";
      // this.user_validated += 1;
     }
   }
 }
 validate_gender() {
 
 // if (this.checkgender != true) {
    if (this.opdvisitService.patientdetails.sex== null || this.opdvisitService.patientdetails.sex== " ") {
      this.validategender=true;
     this.user_validated = this.user_validated + " " + "Gender, " +" \n";
    }
 // }
}
validate_emergency_mob_no() {
   
  if (this.patient_mendatory_fields[0].mandatoryEmergencyMob == true) {
    if (this.digits_count(this.opdvisitService.patientdetails.emmergencyNo) > 9) {
      if (this.opdvisitService.patientdetails.emmergencyNo == null || (this.opdvisitService.patientdetails.emmergencyNo).toString() == "") {
        this.validateemergencymobno=true;
        this.user_validated = this.user_validated + " " + "EMERGENCY MOB NO, " + " \n";
      }
    } else {
      this.validateemergencymobno=true;
      this.user_validated = this.user_validated + " " + "EMERGENCY MOB NO SHOULD BE 10 DIGIT, " + " \n";
     
    }

  } else {
    if (this.opdvisitService.patientdetails.emmergencyNo != null && this.opdvisitService.patientdetails.emmergencyNo.toString() != "" && this.opdvisitService.patientdetails.emmergencyNo.toString() != " ") {
      if (this.digits_count(this.opdvisitService.patientdetails.emmergencyNo) > 9) {

      } else {
        this.user_validated = this.user_validated + " " + "EMERGENCY MOB NO SHOULD BE 10 DIGIT, " + " \n";
      }
    }
  }
}
 validate_DOBAge() {

  if (this.opdvisitService.patientdetails.ageYear == null || this.opdvisitService.patientdetails.ageYear==undefined) {
    this.validateDOBAge=true;
   this.user_validated = this.user_validated + " " + "Age, " +" \n";
  }

}
 savedetails() {
  if(this.opdvisitService.patientdetails.ageYear <= 200){
    if (this.opdvisitService.patientdetails.pkRegId == 0 ||
      this.opdvisitService.patientdetails.pkRegId == null) {
        this.checkphone_no();
      //  this.opdvisitService.savepatientdetails();
 
    }
    else if (this.opdvisitService.patientdetails.pkRegId > 0) {
    
      this.opdvisitService.updatepatient();
    }
   }else{
    this.dashboardService.openSnackBar("Age Can't More than 200 Year", "OK");
   }
  
 }
//  setreferrtype() {
 
//   this.opdvisitService.reffertypeid = this.opdvisitService.patientdetails.fkReferredbyId;
// }
 onNoClick(){
   this.dialog.closeAll();
   this.opdvisitService.patientdetails={};
   this.opdvisitService.checkshort=false;
 }
 getmrnolabel(label: string){
  
if(label == ""){
 return "Old UHID"
}
else {
 return label;
}
 }

digits_count(n) {
  var count = 0;
  if (n >= 1) ++count;

  while (n / 10 >= 1) {
    n /= 10;
    ++count;
  }

  return count;
}

letterOnly(event) 
  {       
       
              var charCode = event.keyCode;
  
              if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 46 || charCode == 32)
  
                  return true;
              else
                  return false;
  }
  
  reMovedata(event:any){
  
    if(event == ""){
      this.clear_and_set_default();
    }
  
  }
  onFocusGetPatient(event) {
    if( this.controlfocusout !=true){
      let inputVal = event.target.value
    if (inputVal != '') {
      this.opdvisitService.getpatientdetails(inputVal);
     
    }
    }
   
  }
  checkphone_no() {    
   // this.open_loader_DialogShort();
   this.dashboardService.showspinner = true;
      if (this.digits_count(this.opdvisitService.patientdetails.phoneRes) > 9 || this.opdvisitService.patientdetails.phoneRes == null || this.opdvisitService.patientdetails.phoneRes == undefined) {
        if (this.digits_count(this.opdvisitService.patientdetails.mobileNo) > 9 || this.patient_mendatory_fields[0].mandatoryMobile == false) {
        
            this.dashboardService.getMobilenUmber(this.opdvisitService.patientdetails.mobileNo)
            .subscribe(
              data => this.successphoneno(data),
              err => this.failphoneno(err)
            );
  
        }
        else {
          this.dashboardService.openSnackBar(" Number Should Be 10 digit", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("PHONE NO SHOULD BE 10 DIGIT", "OK");
      }
  
  
    }
  
    successphoneno(data) { 
      this.phonedata=data;
      this.dashboardService.showspinner = false;
      if (data.length > 0) {
             
        this.openconfirmation_box();
        
      } else {
        this.controlfocusout =false;
        // this.opdvisitService.patientdetails.EntryFrom ="webNetram";
        this.opdvisitService.savepatientdetails();
      }
    }
  
    failphoneno(err) { }
  
    openconfirmation_box(): void {
      const dialogRef = this.dialog.open(Phoneno_confirmation_dialogComponent, {
        width: "500px",
        data: {
          PhoneData: this.phonedata,
          //userid: this.authService.Loggeduser.userid
         
        }
        
      }
      );
      
     
      dialogRef.afterClosed().subscribe(result => {
        console.log("The dialog was closed");
        // this.dialog.closeAll();
      });
      
    }


    refReasonPOpup(type){
      if(type==6){
        this.dashboardService.get_otherinformation_tab_dd('MARITALSTATUS');
      }else if(type==44)
      {
        this.dashboardService.get_otherinformation_tab_dd('NATIONALITY');
      }else if(type==14){
        this.dashboardService.get_otherinformation_tab_dd('VIPREF');
      }
      const dialogRef = this.dialog.open(HelpListPopupComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '33vw',
        disableClose: true,
         width: '33%',
        
        data: {
            typeid: type
        }
  
      });
  
      dialogRef.afterClosed().subscribe(result => {
       
          if(result !=0){
            if(type ==44){
             var nationaldata = this.dashboardService.GetNationality.filter(item => item.popupDescription == result);
            
             this.opdvisitService.patientdetails.fkNationalityId = nationaldata[0].pkPopupId;
             this.opdvisitService.patientdetails.nationality = result;
              
            }else if(type ==14){
              var vipdata = this.dashboardService.GetVIP.filter(item => item.popupDescription == result);
              this.opdvisitService.patientdetails.fkViprefId=vipdata[0].pkPopupId;
              this.opdvisitService.patientdetails.viptype = result;
            }else if(type ==6){
              var meritaldata = this.dashboardService.MaritalStatus.filter(item => item.popupDescription == result);
              this.opdvisitService.patientdetails.fkMaritalId =meritaldata[0].pkPopupId;
              this.opdvisitService.patientdetails.meritalStatus =result;
            }
          }
      });
    }
    getPateintTempDetails(id){ 

      this.opdvisitService.getPateintTempDetails(id,0,0,0,0).subscribe((data:any)=>{
     if(data != '' && data != null){
      this.opdvisitService.patientdetails=data[0];
      this.opdvisitService.patientdetails.fkPcityId = data[0].fK_PCityId;
       this.opdvisitService.patientdetails.pkRegId = data[0].fK_RegID; 
      this.opdvisitService.patientdetails.paddress = data[0].patientAddress; 
      this.opdvisitService.patientdetails.dob=this.datePipe.transform( data[0].dob,"yyyy-MM-dd");
      if(this.opdvisitService.patientdetails.m_CountryCode==null){
        this.opdvisitService.patientdetails.m_CountryCode='+91';
      }
      this.opdvisitService.get_city_district_state_country(this.opdvisitService.patientdetails.fkPcityId,1);
    
     }else{
      this.dashboardService.openSnackBar("Please Select Temporery Id","ok")
      this.clear_and_set_default(); 
     }
        
      })
     }
     CheckinputDoctor(event: any) {

      var checkdata = event.target.value;
      if (checkdata == "") {
        this.referedbyControll();
        this.opdvisitService.patientdetails.fkReferredbyId = 0;
        // this.ShowDoctorName = null;
      }
    }
    referedbyControll() {
      this.ReferedbyCtrl = new FormControl();
      this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
        .pipe(
          startWith(''),
          map(cat => cat ? this.filterReferedbyfunction(cat) : this.opdvisitService.personmaster.slice())
        );
    }
    newPersonArray:any=[];
    filterReferedbyfunction(name: string) {
      if(name!=null && name != undefined){
        const filterValue = name.toLowerCase();
        const returndata= this.opdvisitService.personmaster.filter(country =>
          country.personName?.toLowerCase().indexOf(filterValue) === 0);
         if(returndata.length==0 && name.length >=3){
          this.opdvisitService.getpersonMasterSpecific('REGISTRATION',name).subscribe((x:any)=>{
           this.newPersonArray =[];
           this.newPersonArray =x;
           this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
           .pipe(
             startWith(''),
             map(cat =>  this.newPersonArray.slice())
           );
          })
         }else{
          return returndata;
         }
      }
    }
     getreferedbyobj(e: any) {
      var val = e.option.value;
      this.opdvisitService.patientdetails.referredBy = val.personName;
      this.opdvisitService.patientdetails.fkReferredbyId = val.pkPersonId;
      this.opdvisitService.reffertypeid=val.pkPersonId;
    }
    
    formattimechange(appttime: string) {
      if (appttime == null) {
      } else {
        var hr_min_sec = appttime.split(".", 2);
        var hr_min = hr_min_sec[0].split(":", 3);
        return hr_min[0] + ":" + hr_min[1];
      }
    }
}

